// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f0e77caf","239":"8a3918d0","553":"9fe1eff3"}[chunkId] + ".chunk.js";
};